"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _wrapRootElement = _interopRequireDefault(require("./wrap-root-element"));

exports.wrapRootElement = _wrapRootElement.default;